import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import _get from 'lodash/get';

import {
    useUserData,
    useDeleteReelStore,
} from '../hooks/store';
import {
    useDictionary,
} from '../hooks/config';
import { Tracking } from 'bdvp-tracking';

import Component from '../components/DeleteReelButton';

const DeleteReelButton = ({
    mediaId,
}) => {

    const dictionary = useDictionary();
    const { userId: pageUserId } = useParams();
    const { data: userData = {} } = useUserData();
    const { isLoggedIn = false, userId = '' } = userData;

    const { deleteReelModalShow } = useDeleteReelStore();
    const onClickHandler = useCallback(() => {

        Tracking.trackClipMenuDeleteReelButtonClick();
        deleteReelModalShow(mediaId);

    }, [
        deleteReelModalShow,
        mediaId,
    ]);

    if (!isLoggedIn || pageUserId !== userId) {

        return null;

    }

    return (
        <Component
            label={_get(dictionary, 'delete', 'Delete')}
            onClick={onClickHandler}
        />
    );

};

DeleteReelButton.propTypes = {
    mediaId: PropTypes.string.isRequired,
};

export default DeleteReelButton;
